import { render, staticRenderFns } from "./array.vue?vue&type=template&id=478c90ee&scoped=true"
import script from "./array.vue?vue&type=script&lang=js"
export * from "./array.vue?vue&type=script&lang=js"
import style0 from "./array.vue?vue&type=style&index=0&id=478c90ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c90ee",
  null
  
)

export default component.exports